module.exports = __webpack_public_path__ + "static/rewards-bg-59af847abcda1bc23fdd64a0c0cf1ec2.jpg";